module.exports = __webpack_public_path__ + "9fbee4cf.png";